<template>
	<div class="operation_box">
		<div class="operation_item">
			<el-dropdown
				split-button type="primary"
				@click="clickStart"
				@command="(command) => command()"
			>
				<i class="fa fa-paper-plane"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item :command="clickStart">
						<i class="fa fa-paper-plane"></i> {{ $t("SellTable.button.startAuction") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickSellWithOption" v-if="canSellWithOption">
						<i class="fa fa-retweet"></i> {{ $t("SellTable.button.revolvingSale") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickReset" v-if="!isBundled()">
						<i class="fa fa-undo"></i> {{ $t("common.button.reset") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickUnbundle" v-if="isBundled()">
						<i class="fa fa-chain-broken"></i> {{ $t("SellTable.button.unbundle") }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";
import {enumDef} from "@/common/enumDefs";

export default {
	methods: {
		clickStart() {
			let { data, colDef } = this.params;
			colDef.setFun(data);
		},
		clickSellWithOption() {
			let { data, colDef } = this.params;
			colDef.sellWithOptionFun(data);
		},
		clickReset() {
			let { data, colDef } = this.params;
			colDef.delFun(data);
		},
		clickUnbundle() {
			let { data, colDef } = this.params;
			colDef.unbundle(data);
		},
		isBundled() {
			let { data } = this.params;
			return data.type === 30;
		}
	},
	computed: {
		...mapGetters({ upTableData: "upTableData", upTabType: "upTabType" }),
		canSellWithOption() {
			return this.params.data.optionId > 0 && this.params.data.type !== enumDef.receivableType.TbBundle;
		},
	}
};
</script>
